import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import prog1 from "../assets/invisiblefence.jpg";
import prog2 from "../assets/boundaries.jpg";
import prog3 from "../assets/towerstotrees.jpg";
//import prog4 from "../assets/slide4.jpg";

const ProgramsCarousel = () => {
  const programs = [
    {
      img: prog1,
      title:
        "The Invisible Fence",
      description:
        "3D Spatial Drivers of Colonial Waterbird Nesting Success in a Human-Altered Chilika Lake",
    },
    {
      img: prog2,
      title:
        "Beyond Biophysical Boundaries ",
      description:
        "Integrating Cultural-Historic Refugia into Egyptian Vulture Habitat Models in the Eastern Ghats of Odisha, India",
    },
    {
    img: prog3,
    title: "From Towers to Trees",
    descriptionParts: [
      "Integrating Science, Community Stewardship, and Policy Reform to Restore Habitats and Conserve the White-bellied Sea-Eagle ",
      "Haliaeetus leucogaster",
      " along the Odisha Coast",
    ],
    },
    // {
    //   img: prog4,
    //   title: "Forest Protection",
    //   description:
    //     "Engaging communities and enforcing conservation protocols to safeguard forest ecosystems across Odisha.",
    // },
  ];

  return (
    <section className="py-16 bg-black text-white">
      {/* Heading */}
      <h2 className="text-3xl font-bold text-center text-lime-400 mb-8">
        ONGOING PROJECTS
      </h2>

      {/* Carousel */}
      <div className="w-11/12 md:w-4/5 mx-auto">
        <Swiper
          modules={[Navigation]}
          navigation
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          loop={true}
        >
          {programs.map((prog, i) => (
            <SwiperSlide
              key={i}
              className="flex flex-col items-center bg-gray-900 rounded-lg shadow-lg overflow-hidden"
            >
              <img
                src={prog.img}
                alt={prog.title}
                className="w-full h-64 object-cover"
              />

              <div className="p-5 text-center">
                <h3 className="text-xl font-semibold text-lime-400 mb-2">
                  {prog.title}
                </h3>
                <p className="text-gray-300 text-sm">
                  {prog.descriptionParts ? (
                    <>
                      {prog.descriptionParts[0]}
                      <em className="italic text-gray-200">
                        ({prog.descriptionParts[1]})
                      </em>
                      {prog.descriptionParts[2]}
                    </>
                  ) : (
                    prog.description
                  )}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ProgramsCarousel;
